/**
 * A tiny in-memory handoff for "Ask about this" (Phase G item 4): carries a
 * composer draft into a channel the user is about to navigate to, without
 * a full page reload. Deliberately not `localStorage`/`sessionStorage` --
 * the plan requires the search excerpt never be blindly copied into a
 * conversation, and a draft the user can still edit or discard before
 * sending is not "shared" content, but it also has no reason to outlive
 * this browser tab's JS runtime (a reload losing an un-sent draft is fine).
 */
const pendingDrafts = new Map<string, string>();

export function setPendingDraft(channelId: string, text: string): void {
  pendingDrafts.set(channelId, text);
}

export function takePendingDraft(channelId: string): string | undefined {
  const text = pendingDrafts.get(channelId);
  pendingDrafts.delete(channelId);
  return text;
}
